import type { 
  PostProfileUpdatePasswordData,
  PostProfileUpdatePasswordResponse,

  PutProfileData,
  PutProfileResponse,

  PostProfileUpdateLanguageData,
  PostProfileUpdateLanguageResponse,

  GetSessionsSessionDataData,
  GetSessionsSessionDataResponse,

  GetSessionsData,
  GetSessionsResponse,

  DeleteSessionsByTokenData,
  DeleteSessionsByTokenResponse,

  DeleteSessionsData,
  DeleteSessionsResponse,

  GetAclData,
  GetAclResponse
} from "@/types/openapi-ts";

import type { AxiosInstance } from "axios";


export function getProfileApiModule(affiliatesApi: AxiosInstance) {
  return {
    postUpdatePassword(pwd: PostProfileUpdatePasswordData['body']) {
      return affiliatesApi.post<PostProfileUpdatePasswordResponse>('/profile/update-password', pwd);
    },
    // postSetupTotp(password) {
    //   return affiliatesApi.post('/profile/setup-totp', { password });
    // },
    putProfileInfo(data: PutProfileData['body']) {
      return affiliatesApi.put<PutProfileResponse>('/profile', data);
    },
    postLanguage(languageCode: PostProfileUpdateLanguageData['body']['language_code']) {
      return affiliatesApi.post<PostProfileUpdateLanguageResponse>('/profile/update-language', { language_code: languageCode });
    },
    getSessionsData() {
      return affiliatesApi.get<GetSessionsSessionDataResponse>('/sessions/session-data');
    },
    getSessions() {
      return affiliatesApi.get<GetSessionsResponse>('/sessions');
    },
    deleteSession(id: string) {
      return affiliatesApi.delete<DeleteSessionsByTokenResponse>(`/sessions/${id}`);
    },
    deleteSessions() {
      return affiliatesApi.delete<DeleteSessionsResponse>('/sessions');
    },
    getAcl() {
      return affiliatesApi.get<GetAclResponse>('/acl');
    },
  }
}